const FAQS = [
    { q: "What wax do you use?", a: "We use a blend of natural coconut and soy wax. It burns cleaner and longer than paraffin, and holds fragrance beautifully." },
    { q: "Are your fragrances natural?", a: "All our fragrance oils are phthalate-free and formulated without harmful chemicals. Many include natural essential oil components." },
    { q: "How long do your candles burn?", a: "Our standard 200ml candle burns for approximately 45–55 hours when cared for correctly. See our Candle Care guide for tips." },
    { q: "Can I return a candle I've burned?", a: "We cannot accept returns on burned candles. If your candle arrived damaged, please contact us within 48 hours with a photo and we'll make it right." },
    { q: "Do you offer wholesale?", a: "Yes — we work with a small number of independent retailers and hotels. Please reach out via our contact form to discuss terms." },
    { q: "Are the vessels recyclable?", a: "Yes. Our borosilicate glass vessels are fully recyclable. We also encourage repurposing them — they make excellent glasses, plant pots, and storage jars." },
    { q: "Do you ship internationally?", a: "We currently ship to the UK, EU, and USA. International orders typically arrive within 7–14 business days." },
];

export function FaqPage() {
    return (
        <div className="min-h-screen pt-40 pb-24">
            <div className="max-w-3xl mx-auto px-6">
                <div className="mb-16">
                    <p className="uppercase tracking-[0.3em] text-sm text-stone-400 mb-4 font-light">Common questions</p>
                    <h1 className="font-serif text-5xl md:text-7xl font-light italic">FAQ</h1>
                </div>
                <div className="space-y-0">
                    {FAQS.map(({ q, a }) => (
                        <div key={q} className="border-t border-stone-100 py-8">
                            <h2 className="font-serif text-lg font-light italic text-stone-900 mb-3">{q}</h2>
                            <p className="text-sm text-stone-600 font-light leading-relaxed">{a}</p>
                        </div>
                    ))}
                    <div className="border-t border-stone-100" />
                </div>
            </div>
        </div>
    );
}
